export const GLOBAL_FILTERS_SLICE_NAME = "globalFilters"
